/**
 * Config format
 * multiselect: boolean, enable multiselect, default - false
 * maxMultiSelected: number, show max items when multiselect is enabled, default - 3
 * id: string, field name for unique id item value, default - 'id'
 * label: string, field name for displayed item, default - 'label'
 * splitSelected: boolean, show selected item/items before all other items, default - false
 * showSearch: boolean, default - false
 * animation: string, default - slide-in-up
 * showReset: boolean, default - false
 */

angular.module('custom-select', []);

angular.module('custom-select')
    /**
     * Custom single/multi select component
     */
    .directive('customSelect', ['$state', '$ionicModal', '$timeout', '$compile', '$interpolate', '$ionicScrollDelegate',
        function ($state, $ionicModal, $timeout, $compile, $interpolate, $ionicScrollDelegate) {
            return {
                templateUrl: 'shared/directives/custom-select/CustomSelect.html',
                restrict: 'E',
                require: {ngModelCtrl: 'ngModel'},
                bindToController: true,
                controllerAs: 'ctrl',
                bindings: {
                    ngModel: '<'
                },
                scope: {
                    items: '=',
                    config: '=',
                    wrapClass: '=',
                    onClose: '&',
                    onSelect: '&'
                },
                transclude: true,
                controller: class CustomSelectComponent {
                    constructor($scope) {
                        this.$scope = $scope;
                        this.modal = null;
                        this.search = {};

                        this.selectedItems = [];
                    }

                    $onInit() {
                        console.log('got on init event');

                        this.config = _.merge({
                            multiselect: false,
                            id: 'id',
                            label: 'label',
                            splitSelected: false,
                            showSearch: true,
                            animation: 'slide-in-up',
                            maxMultiSelected: +Infinity,
                            showReset: false,
                            itemHeight: '55px',
                            itemWidth: '100%',
                        }, this.config);

                        this.initModal()
                            .then((modal) => {
                                this.modal = modal;
                            })

                        // items initialization
                        this.items = this.items.map(item => {
                            return _.merge(item, {
                                $id: item[this.config.id],
                                $label: item[this.config.label]
                            })
                        });

                        //initialize selected items from ngModel (if passed)
                        this.initSelectedItems();

                        // watch changes in selected values from outside
                        this.modelWatch = this.$scope.$watch(() => this.ngModelCtrl.$modelValue, (newVal, oldVal) => {
                            // console.log('Got model change', 'old val:', oldVal, 'new val:', newVal);
                            this.initSelectedItems();
                        })
                    }

                    initModal() {
                        return $ionicModal.fromTemplateUrl('custom-select-modal.html', {
                            scope: this.$scope,
                            animation: this.config.animation
                        });
                    }


                    initSelectedItems() {

                        function setItem(modelValue, config) {
                            return _.merge(modelValue, {
                                $id: modelValue[config.id],
                                $label: modelValue[config.label]
                            })
                        }

                        return $timeout(() => {
                            // ng-model value is absent
                            if (!this.ngModelCtrl.$modelValue) {
                                this.selectedItems = [];
                                return;
                            }

                            // always use array to store selected items (even for single select)
                            this.selectedItems = [].concat(this.ngModelCtrl.$modelValue)
                                .map(item => setItem(item, this.config));

                            // console.log('selected items:', this.selectedItems)
                        }, 0)
                    }

                    // TODO - memoization
                    isSelected(item) {
                        if (!item) {
                            return false
                        }
                        return _.find(this.selectedItems, {'$id': item.$id})
                    }

                    getTranscludedContent(context, selector) {
                        if (!this.$scope.transcludeContent.enabled) {
                            return
                        }

                        const ctx = _.cloneDeep(context);

                        return $interpolate(this.$scope.transcludeContent[selector])({ctx});
                    }

                    prepareTranscludedContent(clone) {
                        const html = angular.element(clone);
                        const transcluded = {
                            enabled: false
                        }

                        Array.from(html)
                            // only <script> tags
                            .filter(item => /script/i.test(item.tagName))
                            // that have id
                            .filter(item => item.id.length)
                            .forEach(item => {
                                transcluded[item.id] = item.text;
                                transcluded.enabled = true;
                            });
                        return transcluded;
                    }

                    openSelectModal() {
                        // re-init selected items on modal open
                        this.initSelectedItems();
                        this.modal.show();
                        $ionicScrollDelegate.scrollTop();
                    }

                    selectItem(item) {
                        // console.log('selected item', item);

                        if (this.config.multiselect) {
                            // if item is already in selected - remove it
                            if (_.find(this.selectedItems, {'$id': item.$id})) {
                                return this.deselectItem(item)
                            }
                            // otherwise - add to selected
                            this.selectedItems.push(item);
                            return;
                        }

                        // set selected
                        this.selectedItems = [item];

                        // send to ng-model
                        this.ngModelCtrl.$setViewValue(this.selectedItems[0]);

                        // close modal for single select only
                        if (!this.config.multiselect) {
                            this.closeSelectModal()
                        }
                    }

                    // remove item from selected (for multiselect only)
                    deselectItem(item) {
                        if (this.config.multiselect) {
                            _.remove(this.selectedItems, {'$id': item.$id});
                        }
                    }

                    // apply multi selection to ng-model
                    applySelected() {
                        this.ngModelCtrl.$setViewValue(this.selectedItems);
                        // console.log('apply selected items', this.selectedItems)
                        this.closeSelectModal()
                    }

                    closeSelectModal() {
                        if (this.modal.isShown()) {
                            this.search = {};
                            this.onClose();
                            this.modal.hide();
                        }
                    }

                    resetSearch() {
                        this.search = {};
                    }

                    resetSelection() {
                        this.selectedItems = [];
                        // TODO do not reset parent model, only on apply
                        this.ngModelCtrl.$setViewValue(this.selectedItems);
                    };

                    $onChanges(changes) {
                        // console.log('got changes event', changes);
                    }

                    $onDestroy() {
                        // console.log('got on destroy event');
                        this.$scope.transcludeContent = null;
                        if (this.modal) {
                            this.closeSelectModal();
                            this.modal.remove();
                        }
                        this.modelWatch && this.modelWatch();
                    }

                    $postLink() {
                        // console.log('got postlink event');
                    }
                },
                $transclude: function (el, scope) {
                    console.log('$transclude', el, scope)
                },
                link: function (scope, element, attrs, ctrl, transclude) {
                    transclude(function (clone) {
                        scope.transcludeContent = scope.ctrl.prepareTranscludedContent(clone);
                        scope.attrs = attrs;
                    });
                }
            }
        }])
    /**
     * Filter items with excluded list
     */
    .filter('selectedFilter', function () {
        return function (items, name, exclude, enabled) {
            if (!enabled) {
                return items
            }
            return _.differenceBy(items, exclude, name)
        }
    })
    .filter('unsafe', function($sce) { return $sce.trustAsHtml; });
